export default "__VITE_ASSET__Bs_5uDze__"